import { useMemo } from 'react';

import useRegions from '@/sections/region/hooks/useRegions';

export const useGetCommunesFromRegion = ({
  regionId
}: {
  regionId: string;
}) => {
  const { data: regions } = useRegions();

  const availableCommunesByRegion = useMemo(() => {
    if (!regionId) return [];

    const selectedRegion = regions.find(
      (region) => region.id === Number(regionId)
    );

    const availableCommunes = selectedRegion?.communes?.map((commune) => ({
      value: commune?.code?.toString(),
      name: commune?.name?.toString()
    }));

    return availableCommunes ?? [];
  }, [regionId, regions]);

  return availableCommunesByRegion;
};
